import { AsyncReduxState } from '../@config/AsyncReduxState'

export enum AuthenticateFailureReason {
    invalidCredentials = 'invalidCredentials',
    unknown = 'unknown',
}

export type AuthenticationState = AsyncReduxState<{
    newPasswordSuccess: boolean;
    isAuthenticated: boolean;
    apiToken: string | null;
    apiRefreshToken: string | null;
    authenticateFailure: AuthenticateFailureReason | null;
    errors: string[];
}>;
